import Ext from "Ext";
import messageResource from "../../messageResource";
import FlatButton from "../at_flat_button";
import GroupType from "../../enums/GroupType";

const GroupSelectorSwitcher = Ext.extend(Ext.Panel, {

    cls: "viewByPanel",

    init: function(userGroupsEnabled, timeZoneGroupsEnabled, groupByUserGroupCallback, groupByTimeZoneGroupCallback)
    {
        this.userGroupsEnabled = userGroupsEnabled;
        this.timeZoneGroupsEnabled = timeZoneGroupsEnabled;

        this.groupByUserGroupCallback = groupByUserGroupCallback;
        this.groupByTimeZoneGroupCallback = groupByTimeZoneGroupCallback;

        this.addComponents();

        if (!userGroupsEnabled)
            this.addClass("uzgDisabled");

        if (!timeZoneGroupsEnabled)
            this.addClass("tzgDisabled");
    },

    addComponents: function()
    {
        if (this.userGroupsEnabled && this.timeZoneGroupsEnabled)
        {
            this.addSortByUserGroupLink();
            this.addSortByTimeZoneGroupLink();
        }
        else if (this.userGroupsEnabled)
        {
            this.addTextPanel(messageResource.getEscapedMessage("user_selector.group_by.by_user_groups") + ":");
        }
        else if (this.timeZoneGroupsEnabled)
        {
            this.addTextPanel(messageResource.getEscapedMessage("user_selector.group_by.by_time_zone_groups") + ":");
        }
    },

    addSortByUserGroupLink: function()
    {
        this.addSortByLink(messageResource.getEscapedMessage("user_selector.group_by.by_user_groups"), "userGroupLabel", this.groupByUserGroupCallback);
    },

    addSortByTimeZoneGroupLink: function()
    {
        this.addSortByLink(this.getSortByTimeZoneGroupLinkText(), "timeZoneGroupLabel", this.groupByTimeZoneGroupCallback);
    },

    getSortByTimeZoneGroupLinkText: function()
    {
        return messageResource.getEscapedMessage("user_selector.group_by.by_time_zones");
    },

    addSortByLink: function(text, className, groupByCallback)
    {
        var sortByTimeZoneGroupLink = new FlatButton({
            text: text,
            cls: "sortingLabel " + className
        });
        sortByTimeZoneGroupLink.on("click", groupByCallback, this);
        this.add(sortByTimeZoneGroupLink);
    },

    addTextPanel: function(text)
    {
        this.add(new Ext.Panel(
                {
                    html: text,
                    cls: "sortingLabel textLabel"
                }
        ));
    },

    updateUI: function(groupType)
    {
        this.removeClass('groupedByUserGroup');
        this.removeClass('groupedByTimeZoneGroup');
        if (groupType)
        {
            if (groupType == GroupType.TIME_ZONE_GROUP)
            {
                this.addClass('groupedByTimeZoneGroup');
            }
            else
            {
                this.addClass('groupedByUserGroup');
            }
        }
    }

});

Ext.reg("at_group_selector_switcher", GroupSelectorSwitcher);

export default GroupSelectorSwitcher;


// WEBPACK FOOTER //
// ./web/js/controls/selectorControls/at_group_selector_switcher.js